import API from '@aws-amplify/api';
import { getTicketKnowledgeList, getDrillDownSearch, searchTicketKnowledgeList, getDataPublicRange } from '@/graphql/queries';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';


/**
 * Search ticket knowledge by filter
 * @param {*} APIClient 
 * @param {*} filterInput 
 * @returns ticketKnowledgeList
 */
export const searchTicketKnowledgeListByFilter = async (APIClient, filterInput) => {
    let ticketKnowledgeList = [];
    try {
        let params = {
            query: searchTicketKnowledgeList,
            variables: {
                params: {
                    affiliationOrganization: filterInput.affiliationOrganization,
                    ticketIdList: Utils.isEmptyArray(filterInput.ticketIdList) ? [] : filterInput.ticketIdList,
                    formIdList: Utils.isEmptyArray(filterInput.formIdList) ? [] : filterInput.formIdList,
                    tagFieldIdList: Utils.isEmptyArray(filterInput.tagFieldIdList) ? [] : filterInput.tagFieldIdList
                }
            },
        };
        let resData = await API.graphql(params);
        ticketKnowledgeList = resData.data.searchTicketKnowledgeList;
    } catch (err) {
        console.log('searchTicketKnowledgeListByFilter error: ', err)
    }
    return ticketKnowledgeList;
};



/**
 * Search ticket knowledge list
 * @param {*} APIClient 
 * @param {*} filterInput 
 * @returns ticketKnowledgeList
 */
export const searchTicketKnowledge = async (APIClient, filterInput) => {
    try {
        let params = {
            query: getTicketKnowledgeList,
            variables: {
                params: {
                    userId: filterInput.userId,
                    projectInuse: filterInput.projectInuse,
                    userAffiliationOrganization: filterInput.userAffiliationOrganization,
                    projectInuseType: filterInput.projectInuseType,
                    visibilitySetting: filterInput.visibilitySetting,
                    visibilitySettingType: filterInput.visibilitySettingType,
                    affiliationProject: filterInput.affiliationProject,
                    affiliationOrganization: filterInput.affiliationOrganization,
                    // publicRange: filterInput.publicRange,
                    drillDownSearch: filterInput.drillDownSearch,
                    optionSearch: filterInput.optionSearch,
                    ticketIdList: Utils.isEmptyArray(filterInput.ticketIdList) ? [] : filterInput.ticketIdList,
                    ticketProperty: filterInput.ticketProperty,
                    from: filterInput.from,
                    size: filterInput.size,
                    logKibanaData: filterInput.logKibanaData,
                    optionsSort: filterInput.optionsSort
                }
            },
        };

        let resData = await API.graphql(params);
        let resTicketKnowledgeList = resData.data.getTicketKnowledgeList;
        let ticketKnowledgeList = resTicketKnowledgeList?.ticketKnowledgeListInfo || [];
        let totalTickets = resTicketKnowledgeList?.totalTickets || 0;
        let inviterUsingChatAI = resTicketKnowledgeList?.inviterUsingChatAI;
        if (filterInput.ticketProperty === Constant.TICKET_PROPERTY.DELETE) {
            ticketKnowledgeList = Utils.sortByDeletedAtAsc(ticketKnowledgeList);
        }
        return {ticketKnowledgeList, totalTickets, inviterUsingChatAI};
    } catch (err) {
        console.log('searchTicketKnowledge error: ', err)
        return [];
    }
};

/**
 * getDrilldownData
 * @param {} APIClient 
 * @param {*} args 
 * @returns 
 */
export const getDrilldownData = async (APIClient, args, setCurrentSearchParams = () => {}) => {
    try {
        const requestParams = {
            corporationId: args.corporationId,
            projectId: args.projectId,
            userId: args.userId,
            isCustomer: args.isCustomer,
            visibility: args.visibility,
            viewStructure: JSON.stringify(args.viewStructure),
            ticketProperty: args.ticketProperty,
            size: args?.size,
            from: args?.from,
            projectInuse: args.projectInuse,
            userAffiliationOrganization: args.userAffiliationOrganization,
            projectInuseType: args.projectInuseType,
        };

        if (!args.searchAfter) {
            setCurrentSearchParams(requestParams)
        }

        if (args.searchAfter) {
            requestParams.searchAfter = JSON.stringify(args.searchAfter);
        }

        let params = {
            query: getDrillDownSearch,
            variables: {
                params: requestParams
            },
        };

        let resData = await API.graphql(params);
        let ticketKnowledgeList = resData.data.getDrillDownSearch;
        return ticketKnowledgeList;
    } catch (err) {
        console.log('getDrilldownData error: ', err)
        return [];
    }
}

/**
 * getPublicRangeData
 * @param {} APIClient 
 * @param {*} args 
 * @returns 
 */
export const getPublicRangeData = async (APIClient, args) => {
    try {
        const requestParams = {
            corporationId: args.corporationId,
            projectId: args.projectId,
            userId: args.userId,
            isCustomer: args.isCustomer,
            visibility: args.visibility,
            viewStructure: JSON.stringify(args.viewStructure),
            ticketProperty: args.ticketProperty,
            size: 5000,
            from: args?.from,
            projectInuse: args.projectInuse,
            userAffiliationOrganization: args.userAffiliationOrganization,
            projectInuseType: args.projectInuseType,
        };

        if (args.searchAfter) {
            requestParams.searchAfter = JSON.stringify(args.searchAfter);
        }

        let params = {
            query: getDataPublicRange,
            variables: {
                params: requestParams
            },
        };

        let resData = await API.graphql(params);
        let dataPublicRange = resData.data.getDataPublicRange;
        return dataPublicRange;
    } catch (err) {
        console.log('getDataPublicRange error: ', err)
        return [];
    }
}